package com.eladfinish.bible.contest.screens.browse.contentOfChapter.ui

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.SecondaryScrollableTabRow
import androidx.compose.material3.Tab
import androidx.compose.material3.TabRowDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.left_arrow
import com.eladfinish.bible.contest.right_arrow
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.BrowseChaptersState.PartTabSpec
import com.eladfinish.bible.contest.ui.common.accentColor
import com.eladfinish.bible.contest.ui.components.mouseWheelHorizontalScroll
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.ImmutableList

@Composable
internal fun ChapterTabsRow(
    selectedTabIndex: Int,
    tabs: ImmutableList<PartTabSpec>,
    onTabClick: (tabIndex: Int, tabSpec: PartTabSpec) -> Unit,
) {
    if (tabs.isEmpty()) return

    val safeSelectedTabIndex = selectedTabIndex.coerceIn(minimumValue = 0, maximumValue = tabs.lastIndex)

    val scrollState = rememberScrollState()

    SecondaryScrollableTabRow(
        selectedTabIndex = safeSelectedTabIndex,
        modifier = Modifier
            .fillMaxWidth()
            .mouseWheelHorizontalScroll(scrollState),
        scrollState = scrollState,
        edgePadding = 0.dp,
        containerColor = colorResource(SharedRes.colors.colorPrimaryDark),
        indicator = {
            TabRowDefaults.SecondaryIndicator(
                modifier = Modifier.tabIndicatorOffset(
                    selectedTabIndex = safeSelectedTabIndex,
                    matchContentSize = false,
                ),
                color = accentColor,
            )
        },
    ) {
        tabs.forEachIndexed { index, tabSpec ->
            ChapterTab(
                tabSpec = tabSpec,
                selected = safeSelectedTabIndex == index,
                onClick = { onTabClick(index, tabSpec) },
            )
        }
    }
}

@Composable
private fun ChapterTab(
    tabSpec: PartTabSpec,
    selected: Boolean,
    onClick: () -> Unit,
) {
    Tab(
        selected = selected,
        onClick = onClick,
        text = {
            Text(
                text = tabSpec.label(),
                color = if (selected) accentColor else Color.White,
            )
        },
    )
}

@Composable
private fun PartTabSpec.label(): String {
    return when (this) {
        PartTabSpec.ArrowRight -> stringResource(SharedRes.strings.right_arrow)
        PartTabSpec.ArrowLeft -> stringResource(SharedRes.strings.left_arrow)
        is PartTabSpec.Part -> stringDesc.localized()
    }
}
